import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { StorageService } from '../interceptor/storage.service';

@Injectable({
  providedIn: 'root',
})
export class AllinoneService {
  
  public DynamicMenu = new BehaviorSubject(false);

  public DynamicRoles = new BehaviorSubject(undefined);

  public DynamicToken = new BehaviorSubject(undefined);

  public Dynamicuser = new BehaviorSubject(undefined);

  public DynamicTokenFalse = new BehaviorSubject(false);

  public Dynamicnotifications = new BehaviorSubject(false);

  public Dynamicheader = new BehaviorSubject(false);

  public DynamicLocation = new BehaviorSubject(undefined);

  constructor(private store: StorageService) {}

  setdynamicmenu() {
    const data: any = this.store.getvariable();
    this.DynamicMenu.next(data);
  }

  setRoles() {
    const data: any = this.store.getRoles();
    this.DynamicRoles.next(data);
  }

  setToken() {
    const data: any = this.store.getToken();
    this.DynamicToken.next(data);
  }

  setUser() {
    const data: any = this.store.getuser();
    this.Dynamicuser.next(data);
  }

  setUserSetting(data:any) {
    // console.log(data);
    this.store.setusername(data);
    this.Dynamicuser.next(data);
  }

  setdynamicHeader(data:any) {
    this.Dynamicheader.next(data);
  }

  setTokenboolean(data:any) {
   // //console.log(data)
    this.DynamicTokenFalse.next(data);
  }
  

  setnotfications(data:any) {
   // //console.log(data)
    this.Dynamicnotifications.next(data);
  }

  setallLocation() {
    const data: any =  localStorage.getItem('locationset');
    this.DynamicLocation.next(JSON.parse(data));
  }
}
